import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { FeriadoPage } from '../pages/feriado.page';

const FeriadoRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/feriado' element={<FeriadoPage />} />
    </Routes>
  );
};

export { FeriadoRoutes };
